/* eslint-disable func-names, prefer-template */
/* globals DocMenus */

window.DocMenus = {
  openSectionOfCurrentPage() {
    const $currentDocPage = $('a[href="' + $('[data-stickysidebar]').data('current-item') + '"]');
    let $li = $currentDocPage.parent('li');
    $li.addClass('active-section');

    // Open parent & parent of parent if correct structure and type
    $li = $li.parent('ul').parent('li.no-link');
    $li.toggleClass('active-section');
    $li = $li.parent('ul').parent('li.no-link');
    $li.toggleClass('active-section');
  },

  setupSectionClassToggleOnClick() {
    const navRoots = $('[data-sidebar-accordion-toggle]');
    navRoots.on('click', function (event) {
      const $this = $(this);
      if ($this.hasClass('active-section')) {
        $this.removeClass('active-section');
      } else {
        $this.addClass('active-section');
        $this.siblings().removeClass('active-section');
      }
      event.stopPropagation();
      // force update on collapse/expand
      window.sidebarInstances.forEach(function (instance) {
        instance.updateSticky();
      });
    });
    navRoots.find('li:not(.no-link)>a').on('click', function (event) {
      // Prevent link press event propagating to the parent nav item and closing / opening the nav
      event.stopPropagation();
    });
  },

  setupJumpMenu() {
    if ($('[data-jump-menu-link]').length === 0 || $('[data-scope*="tutorials-show"]').length > 0) {
      $('[data-js-header-wrap]').addClass('has-docs-menu has-jump-menu');
    }

    DocMenus.setCurSection();

    $(window).on('scroll', DocMenus.setCurSection);
  },

  destroyJumpMenu() {
    $(window).off('scroll', DocMenus.setCurSection);
  },

  setCurSection() {
    // needs to be calculate here since the class
    // that increases header height (has-docs-menu) is add on the setup
    const curHeaderHeight = $('[data-js-header]').outerHeight();
    const offsets = [];
    const targets = [];
    const $win = $(window);
    const $jumpmenuInline = $('[data-jump-menu]');

    const $validMenuLinks = $jumpmenuInline.find('a[href]:not(:empty):not(.is-hidden-due-specific-lang)');
    $validMenuLinks.removeClass('active is-active');

    $validMenuLinks.each(function () {
      const target = $(this).attr('href');
      try {
        if (target.indexOf('#') === 0) {
          offsets.push(DocMenus.targetOffset($win, curHeaderHeight, target));
          targets.push(target);
        }
      } catch (e) {
        /* continue regardless of error */
      }
    });

    $validMenuLinks.each(function () {
      const $this = $(this);
      const $jumpMenutitle = $('[data-jump-menu-title]');

      if ($this.attr('href') === DocMenus.closestTarget(targets, offsets)) {
        $this.addClass('active is-active');
        if ($jumpMenutitle) {
          $jumpMenutitle.text($this.text());
        }
      }
    });
  },

  closestTarget(targets, offsets) {
    return targets[offsets.lastIndexOf(Math.min(...offsets))];
  },

  targetOffset($win, headerHeight, target) {
    return Math.abs($(target).offset().top - $win.scrollTop() - headerHeight);
  },
};
